import 'es6-promise/auto'
import Vue from 'vue'
import Axios from 'axios'
import Pager from "./components/common/pagingUser.vue";
import Common from './components/common.js';
import Datepicker from './components/ynadmin/common/datepicker.vue';
import Editor from "./components/common/editor.vue";
import swal from 'sweetalert';
import SwalAlert from "./components/common/swalAlert.vue";
import VueFileAgent from 'vue-file-agent';
import Validator from './components/common/validation.js';
import Share from './components/common/share.js';
import KProgress from 'k-progress';

import 'vue-file-agent/dist/vue-file-agent.css';

Vue.use(VueFileAgent);

import ImgProfile from "./components/common/dragImgProfile.vue";
import DropImg from "./components/common/dragImgFile.vue";
import DropDoc from "./components/common/dragDocFile.vue";
import DropVideo from "./components/common/dragVideoFile.vue";
import DropImgOne from "./components/common/dragImgFileOne.vue";
import ProfileList from "./components/common/dfile1.vue";

Vue.component("pager", Pager);
Vue.component('common', Common);
Vue.component("datepicker", Datepicker);
Vue.component('star-rating', VueStarRating.default);
Vue.component('editor', Editor);
Vue.component('dropimg', DropImg);
Vue.component('imgprofile', ImgProfile);
Vue.component('dropimgone', DropImgOne);
Vue.component('dropdoc', DropDoc);
Vue.component('dropvideo', DropVideo);
Vue.component('k-progress', KProgress);
Vue.component("dfile", ProfileList);

// var CircularJSON = require('circular-json');

Vue.prototype.$datepicker = Datepicker;

const PARE_STATE_KEY = 'pareReviewState';
const PARE_BACK_INTENT_KEY = 'pareBackIntent';

new Vue({
  el: '#pare',
  data: function () {
    return {
      fileImgProfile: [],
      mainName: '학부모기자단',
      w: false,
      showMore : true,
      inputThemeLabel: '',
      onSaving: false,

      selectThemeType: '',

      inputGradeLabel: '',
      selectGradeValue: '',

      vdFile: null,
      commonParams : null,

      //파일 수정용 변수
      vd: null,
      img: null,
      auth:'',
      detailOption: {},
      videoRes: {},

      detailTxt: '',

      declareList: []
      , declareReportCode: ''
      , declareReportEtc: ''
      , isRecommend: false
      , isDeclare: false
      , isShare: false
      , detailProfile: {url: "/design/common/images/sub/img_profile_example01.jpg", name: "", upload: "", type: ""}
      , applyModel: {
        userName: ''
        , cuid: ''
        , address: ''
        , phone: ''
        , email: ''
        , call: ''
        , blog: ''
        , content: ''
        , childcnt: '0'

        , schoolList: []
        , gradeList: []

        , applyUserList: []
        , applyUser: {}

        , uidKey: ''
      }
      , pareDetailModel: {
        pareContents: {}
        , isIntro: false
        , isContents: false
        , boardUid: ''
        , userKey: ''
        , nickName: ''

        //댓글 작성
        , replyList: []
        , rereplyList: []
        , replyName: ''
        , replyPassword: ''
        , replyContents: ''
        , replyStarCnt: ''

        , isReplyOn: false
        , isHideOn: false
        , isModifyOn: false

        //boardDetail 구분자
        , subCtg: ''

        //대댓글 작성
        , reReplyTarget: ''
        , reReplyName: ''
        , reReplyPassword: ''
        , reReplyContents: ''

        //댓글 수정
        , modifyTarget: ''
        , modifyPassword: ''
        , modifyPwCor: ''
        , modifyStarCnt: ''
        , modifyContents: ''

        //댓글 삭제
        , deleteTarget: ''
        , deletePassword: ''
        , deletePwCor: ''

        , reportValues: '1'
        , reportEtcValue: ''
        , pager: {
          model: {},
          pageNo: 1,
          pageNum: 1,
          totalSize: 0,
          rowSize: 10,
          blockSize: 5,
          endSize: 0,
          list: [],
          href: "javascript:void(0);",
          callBack: function (n) {
            if (searchid == 'sosic') {
              this.model.fnGetReviewDetail(n, 'mom_sosic');
            } else {
              this.model.fnOnPareNewsList(n, 'mom_board');
            }

          }
        }
      }
      , pareInsertModel: {
        //검색자동완성변수
        centerList: []
        , reserveList: []
        , isResActive: false
        , isCenActive: false
        , searchResQuery: ''
        , searchCenQuery: ''
        , resValue: ''
        , cenValue: ''

        //폼 입력변수
        , theme: ''
        , title: ''
        , content: ''
        , thumbnailName: ''
        , thumbnailPath: ''
        , mediaUrl: ''
        , youtubeUrl: ''
        , starCnt: 0

        , reserveTitle_input: ''
        , reserveTitle: ''
        , reservePuid: ''
        , reserveId: ''
        , reserveDate: ''
        , reserveProgramType: ''

        , centerName_input: ''
        , centerName: ''
        , centerUid: ''

        , selectItem: null

        , isEmptyPrgm: false

        , isModify: false

        //게시판 수정용 변수
        , uidKey: ''

        //게시판 이용자 정보 변수
        , userKey: ''

        //게시판 - 타입전환
        , isBoard: false
        , category: ''
      }
      , pareNewsModel: {
        list: [{"": ""}]
        , totalCount: 0
        , pageNum: 0
        , kword: ''
        , kind: 'all'
        , bcate: ''
        , pager: {
          model: {},
          pageNo: 1,
          pageNum: 1,
          totalSize: 0,
          rowSize: 10,
          blockSize: 5,
          endSize: 0,
          list: [],
          href: "javascript:void(0);",
          callBack: function (n) {
            let searchid = $(".tab-link.current").attr("id");
            if (searchid == 'sosic') {
              this.model.fnOnPareNewsList(n, 'mom_sosic');
            } else {
              this.model.fnOnPareNewsList(n, 'mom_board');
            }

          }
        }
      }
      , postingModel: {
        contentsList: {}
        , categoryList: []
        , searchCategoryValue: ''
        , themeList: []
      }
      , pareManagerModel: {
        list: [{"": ""}]
        , boardList: [{"": ""}]
        , kword: ''
        , menu: ''
        , kind: 'all'

        , pager: {
          model: {},
          pageNo: 1,
          pageNum: 1,
          totalSize: 0,
          rowSize: 10,
          blockSize: 5,
          endSize: 0,
          list: [],
          href: "javascript:void(0);",
          callBack: function (n) {
            let searchid = $(".on").attr("id");
            if (searchid == 'mentoMom') {
              this.model.fnOnPareManagerList(n, 'mentoMom');
            } else if (searchid == 'local') {
              this.model.fnOnPareManagerList(n, 'local');
            } else {
              this.model.fnOnPareLocalList(n);
            }
          }
        }
      }
      , pareReviewModel:
      {
        reviewList: [{"": ""}],
        kword: '',
        order: 'date',
        bcate: 'parent',
        pager: {
          model: {},
          pageNo: 1,
          pageNum: 1,
          totalSize: 0,
          rowSize: 6,
          blockSize: 5,
          endSize: 0,
          list: [],
          href: "javascript:void(0);",
          callBack: function (n) {
            this.model.fnOnPostList(n);
          }
        }
      },
      pareJinronModel:
      {
        jinronList: [{"": ""}],
        boardCtg: 'S1N1',
        pager: {
          model: {},
          pageNo: 1,
          pageNum: 1,
          totalSize: 0,
          rowSize: 10,
          blockSize: 10,
          endSize: 0,
          list: [],
          href: "javascript:void(0);",
          callBack: function (n) {
            this.model.fnOnJinroNNewsList(n);
          }
        }
      },
    }
  },
  created: function () {
    if (!('$' in Vue.prototype) && '$' in window) {
      Vue.prototype.$ = window.$; // <template> 에서 $ 사용
    }
  },
  mounted: function () {
    let pageType = $("#pageType").val();
    
    // momsReview 페이지에서만 복원 로직 실행
    if (pageType === "momsReview") {
      const nav = performance.getEntriesByType('navigation')[0];
      const isBack = nav && (nav.type === 'back_forward');
      const ref = document.referrer || '';
      const fromDetailPage = ref.indexOf('/customer/pare/detailReview') >= 0 || ref.indexOf('/customer/pare/pareReviewDetail') >= 0;
      const hasBackIntent = sessionStorage.getItem(PARE_BACK_INTENT_KEY) === 'true';
      
      if ((isBack || fromDetailPage) && hasBackIntent) {
        this.restorePareState();
        return;
      }
    }
    
    this.fnOnLoadInit();
  },
  methods: {
    clickFunc: function (event) {
      event.target.focus();// Add me
    },
    fnOnLoadInit: function () {
      let pageType = $("#pageType").val();
      let vm = this;
      this.fnCheckAuth();
      vm.onLoadLoginUser();
      if ("momsReview" == pageType) {
        // vm.mainName = '학부모기자단 리얼후기' // 학부모기자단 추천 유스내비 프로그램
        vm.mainName = '학부모기자단 추천'
        vm.fnOnPostList(1);
      } else if ("detail" == pageType) {
        vm.mainName = '학부모기자단 추천' // 학부모기자단 추천 유스내비 프로그램
        // Kakao.init("f070cfc41d9b03512041e0b74475d4fb");
        Kakao.init("25727a9190252a67c490a909452aecd8");
        vm.fnSetCode("RPTNVYTHNV00000");
        vm.fnGetReviewDetail();
      } else if ("boardDetail" == pageType) {
        vm.mainName = '학부모기자단 게시판'
        //Kakao.init("f070cfc41d9b03512041e0b74475d4fb");
        Kakao.init("25727a9190252a67c490a909452aecd8");
        vm.fnSetCode("RPTNVYTHNV00000");
        vm.fnGetBoardDetail();
      } else if ("insertReview" == pageType) {
        vm.mainName = '학부모기자단 추천 작성'
        let type = $("#type").val();
        if (type == "modify") {
          vm.mainName = '학부모기자단 추천 수정'
          vm.fnSetReviewModify();
          $("#reserveTitle").attr("disabled", true);
        }
        vm.fnAllSetList();
      } else if ("pareNews" == pageType) {
        vm.mainName = '학부모기자단 소식'
        let tab = $("#tab").val();

        if (tab == "2") {
          $("#mom_board").addClass('on');
          $("#mom_sosic").removeClass('on');
          vm.fnOnPareNewsList(1, 'mom_board');
        } else {
          vm.fnOnPareNewsList(1, 'mom_sosic');
        }

      } else if ("insertBoard" == pageType) {
        vm.mainName = '게시판 작성'
        let type = $("#type").val();
        if (type == "modify") {
          vm.mainName = '게시판 수정'
          vm.fnSetBoardModify();
        } else {
          vm.fnSetBoardForm();
        }
      } else if ("Mento" == pageType) {
        vm.mainName = '멘토/지역장 모임'

        let tab = $("#tab").val();

        if (tab == "3") {
          vm.pareManagerModel.menu = "mentoBoard";
          $("#mentoBoard").addClass('on');
          $("#mentoMom").removeClass('on');
          vm.fnOnPareLocalList(1);
        } else {
          vm.fnOnPareManagerList(1, 'mentoMom');
        }


      } else if ("apply" == pageType) {
        vm.mainName = '학부모기자단 신청'

        let type = $("#type").val();
        if (type == "modify") {
          vm.mainName = '신청정보 수정'
          vm.fnApplyContent();
        } else {
          vm.fnSetApply();
        }

        vm.fnGetSchool();
      } else if ("intro" == pageType) {
        vm.mainName = '학부모기자단'
        vm.fnOnPostList(1);
      } else if ("Jinron" == pageType) {
        vm.mainName = '진로/진학 콘텐츠'
        vm.fnOnJinroNNewsList(1, 'S1N1');
      }

    }
    , extractContent(s) {
      var span = document.createElement('span');
      span.innerHTML = s;
      return span.textContent || span.innerText;
    },
    onLoadLoginUser() {
      let param = {};
      let vm = this;
      Axios.post("/api/user/init/check", param).then(function (response) {
        vm.commonParams = response.data.commonParams;
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    /****************************************************************************/
    //학부모기자단 신청 정보 셋팅
    fnSetApply() {
      let vm = this;

      let param = {};

      Axios.post("/api/pare/settingInfo", param).then(function (response) {
        vm.applyModel.userName = response.data.userName;
        vm.applyModel.userKey = response.data.userKey
        vm.applyModel.phone = vm.fnChgTelNum(response.data.phone);
        vm.applyModel.tel = response.data.bcate;
        vm.applyModel.email = response.data.email;

        $("#fileKey").val(response.data.fileKey);
        $("#usrKey").val(response.data.userKey);

      }).catch(function (ex) {
        console.log(ex);
      });

      vm.applyModel.applyUserList = [];

    }
    , fnGoToPare(path) {
      if (path == 'intro') {
        location.href = '/customer/pare';
      } else if (path == 'review') {
        location.href = '/customer/pare/momsReview';
      }

    }
    , fnApplyContent() {
      let vm = this;

      let param = {};

      Axios.post("/api/pare/settingMyApply", param).then(function (response) {
        let detail = response.data.pareApplyItem;

        let childList = response.data.childList;

        vm.img = response.data.imgFileList;

        vm.applyModel.userName = response.data.userName;
        vm.applyModel.userKey = response.data.userKey
        vm.applyModel.phone = vm.fnChgTelNum(response.data.phone);
        vm.applyModel.tel = response.data.bcate;
        vm.applyModel.email = response.data.email;

        $("#fileKey").val(response.data.fileKey);
        $("#usrKey").val(response.data.userKey);

        vm.applyModel.uidKey = detail.uidKey;
        vm.applyModel.blog = detail.blog;
        vm.applyModel.childcnt = detail.count;
        vm.applyModel.content = detail.intro;

        vm.setChild(detail.count);

        childList.forEach(function (item, index) {
          vm.applyModel.applyUserList[index].name = item.name;
          vm.applyModel.applyUserList[index].schoolType = item.schoolType;
          vm.applyModel.applyUserList[index].grade = item.grade;

          vm.fnPromiseGradeList(vm.applyModel.applyUserList[index], item.schoolType)
            .then(function () {
              return vm.fnPromiseSetGradeNm(vm.applyModel.applyUserList[index], item.grade)
            })
            .then((e) => {
              console.log("success");
            })
        });

      }).catch(function (ex) {

        console.log(ex);
      });

    }
    //학교정보 셀렉트박스 필터
    , schoolFilter: function (value) {
      let vm = this;
      console.log(value);
      if (value == "" || value == null || value == undefined) {
        return "선택"
      } else {
        const _school = vm.applyModel.schoolList.find(item => item.cmm_sys_cd == value);
        let _title = _school.cmm_sys_titl;
        return _title;
      }
    }
    //학년정보 셀렉트박스 필터
    , gradeFilter: function (value, _item) {
      let vm = this;
      _item.grade = value;
      if (value == "" || value == null || value == undefined) {
        _item.gradeNm = "";
      } else {
        const _grade = _item.gradeList.find(item => item.cmm_sys_cd == value);
        let _title = _grade.cmm_sys_titl;
        _item.gradeNm = _title;
      }
    }
    /****************************************************************************/
    //pareReview.jsp
    //리얼리뷰 게시글리스트 가져오기
    , fnOnPostList: function (pageNumber) {
      let vm = this;
      if (pageNumber == 1) {
        vm.pareReviewModel.reviewList = [];
      }
      vm.pareReviewModel.pager.pageNo = pageNumber;

      let param = {
        pageNo: vm.pareReviewModel.pager.pageNo
        , pageSize: vm.pareReviewModel.pager.rowSize
        , kword: vm.pareReviewModel.kword
        , order: vm.pareReviewModel.order
      };
      Axios.post("/api/pare/experience/list", param).then(function (response) {
        vm.pareReviewModel.pager.totalSize = response.data.totalCount;
        vm.pareReviewModel.pageNum = (vm.pareReviewModel.pager.pageNo * vm.pareReviewModel.pager.rowSize) - vm.pareReviewModel.pager.rowSize;
        //Pager.props = Pager.methods.createPager(vm.pareReviewModel.pager, vm, "list");
        vm.pareReviewModel.reviewList = vm.pareReviewModel.reviewList.concat(response.data.pareList);
        if(response.data.pareList.length === 0) {
          vm.showMore = false;
        } else {
          vm.showMore = true;
        }
        
        // 상태 저장
        vm.savePareState();
      }).catch(function (ex) {
        console.log(ex);
      });
    }
    , fnOnJinroNNewsList: function (pageNumber, boardCtg) {

      let vm = this;
      if (pageNumber == 1) {
        vm.pareJinronModel.jinronList = [];
      }
      vm.pareJinronModel.pager.pageNo = pageNumber;
      vm.pareJinronModel.boardCtg = boardCtg;

      let param = {
        pageNo: vm.pareJinronModel.pager.pageNo
        , pageSize: vm.pareJinronModel.pager.rowSize
        , boardCtg: vm.pareJinronModel.boardCtg
      };

      Axios.post("/api/pare/jinron/list", param).then(function (response) {
        vm.pareJinronModel.pager.totalSize = response.data.totalCount;
        vm.pareJinronModel.pageNum = (vm.pareJinronModel.pager.pageNo * vm.pareJinronModel.pager.rowSize) - vm.pareJinronModel.pager.rowSize;
        //Pager.props = Pager.methods.createPager(vm.pareReviewModel.pager, vm, "list");
        vm.pareJinronModel.jinronList = vm.pareJinronModel.jinronList.concat(response.data.pareJinronList);
        if(response.data.pareJinronList.length === 0) {
          vm.showMore = false;
        } else {
          vm.showMore = true;
        }
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    fnGoJinronDetail: function (hrefLink) {
      let vm = this;
      window.open(hrefLink);
    }
    //정렬방식 변경
    , fnChangeOrder(_order) {
      let vm = this;

      vm.pareReviewModel.order = _order;

      vm.fnOnPostList(1);
    }
    /****************************************************************************/
    //리얼리뷰 상세정보 가져오기
    , fnGetReviewDetail() {
      let vm = this;

      let param = {
        uidKey: $("#uid").val()
      };
      Axios.post("/api/pare/experience/detail", param).then(function (response) {

        vm.pareDetailModel.pareContents = response.data.pareReviewDetail;

        document.title = response.data.pareReviewDetail.title;
        vm.pareDetailModel.replyList = response.data.pareBcomList;
        vm.pareDetailModel.rereplyList = response.data.pareReBcomList;

        if (response.data.vdFileList.length > 0) {
          response.data.vdFileList.forEach(function (video) {
            vm.vdFile = video.file_new_name.substr(0, 8) + "/" + video.file_new_name.split(".")[0] + ".mp4";
          });
        }


        if (vm.pareDetailModel.pareContents.rcmmYn == "Y") {
          vm.isRecommend = true;
        } else {
          vm.isRecommend = false;
        }

        vm.pareDetailModel.boardUid = $("#uid").val();
        vm.pareDetailModel.userKey = response.data.userKey;
        vm.pareDetailModel.nickName = response.data.userName;

      }).catch(function (ex) {
        console.log(ex);
      });
    }
    //리뷰 수정을 위한 준비
    , fnSetReviewModify() {
      let vm = this;
      let param = {
        uidKey: $("#uidKey").val()
      };
      Axios.post("/api/pare/review/modify", param).then(function (response) {

        let pareContents = response.data.pareReviewDetail;
        vm.pareInsertModel.uidKey = pareContents.uidKey;
        vm.pareInsertModel.title = pareContents.title;
        vm.pareInsertModel.content = pareContents.content;
        vm.pareInsertModel.starCnt = pareContents.starCnt;

        vm.pareInsertModel.reserveTitle = pareContents.programName;
        vm.pareInsertModel.reservePuid = pareContents.programUid;
        vm.pareInsertModel.reserveId = pareContents.programRegUid;
        vm.pareInsertModel.reserveDate = pareContents.programRegDate;
        vm.pareInsertModel.reserveProgramType = pareContents.programType;

        vm.pareInsertModel.centerName_input = pareContents.centerName;
        vm.pareInsertModel.centerUid = pareContents.centerUid;
        vm.pareInsertModel.youtubeUrl = (pareContents.youtubeUrl == null || pareContents.youtubeUrl == '') ? "" : pareContents.youtubeUrl;

        vm.img = response.data.imgFileList;
        vm.vd = response.data.vdFileList;

        //대표이미지 파일 최대갯수 셋팅
        vm.$refs.dropimg.onMaxChange(1);
        vm.pareInsertModel.isModify = true;

      }).catch(function (ex) {
        console.log(ex);
      });
    }
    //학부모기자단 게시글 수정정보 가져오기
    , fnSetBoardModify() {
      let vm = this;
      let param = {
        uidKey: $("#uidKey").val()
      };
      Axios.post("/api/pare/board/modify", param).then(function (response) {
        let pareContents = response.data.pareReviewDetail;
        vm.pareInsertModel.uidKey = pareContents.uidKey;
        vm.pareInsertModel.title = pareContents.title;
        vm.pareInsertModel.content = pareContents.content;
        vm.pareInsertModel.category = pareContents.category;
        vm.pareInsertModel.userKey = $("#userKey").val();
        vm.pareInsertModel.youtubeUrl = (pareContents.youtubeUrl == null || pareContents.youtubeUrl == "") ? "" : pareContents.youtubeUrl;
      }).catch(function (ex) {
        console.log(ex);
      });
    }
    //학부모기자단 게시글 상세정보 가져오기
    , fnGetBoardDetail() {
      let vm = this;
      let param = {
        uidKey: $("#uid").val()
        , userKey: $("#userKey").val()
      };
      Axios.post("/api/pare/board/detail", param).then(function (response) {

        vm.pareDetailModel.pareContents = response.data.pareReviewDetail;
        document.title = response.data.pareReviewDetail.title;
        vm.pareDetailModel.replyList = response.data.pareBcomList;
        vm.pareDetailModel.rereplyList = response.data.pareReBcomList;

        if (response.data.vdFileList.length > 0) {
          response.data.vdFileList.forEach(function (video) {
            vm.vdFile = video.file_new_name.substr(0, 8) + "/" + video.file_new_name.split(".")[0] + ".mp4";
          });
        }

        if (vm.pareDetailModel.pareContents.rcmmYn == "Y") {
          vm.isRecommend = true;
        } else {
          vm.isRecommend = false;
        }

        vm.pareDetailModel.boardUid = $("#uid").val();
        vm.pareDetailModel.userKey = $("#userKey").val();
        vm.pareDetailModel.nickName = $("#nickName").val();
        vm.pareDetailModel.subCtg = vm.pareDetailModel.pareContents.category;

      }).catch(function (ex) {
        console.log(ex);
      });
    },
    fnBackList: function () {
      let vm = this;

      if (vm.pareDetailModel.subCtg == 'BRDNVYTHNV00900') {
        location.href = "/customer/pare/momsBoard";
      } else if (vm.pareDetailModel.subCtg == 'BRDNVYTHNV00910') {
        location.href = "/customer/pare/momsBoard?tab=2";
      } else if (vm.pareDetailModel.subCtg == 'BRDNVYTHNV00930') {
        location.href = "/customer/pare/momsManager?tab=3";
      }
    },
    fnSwalAlert(_text) {
      swal({
        text: _text,
        closeOnClickOutside: false,
        // icon : this.fnOnLoadSwalImageData("warning"),
        buttons: {
          confirm: {
            text: "확인",
            value: true,
            visible: true
          }
          , cancle: {
            text: "취소",
            value: false,
            visible: false
          }
        }
      });
    },
    fnSwalSuccess(_text, successFunction) {
      swal({
        text: _text,
        closeOnClickOutside: false,
        // icon : this.fnOnLoadSwalImageData("success"),
        buttons: {
          confirm: {
            text: "확인",
            value: true,
            visible: true
          }
          , cancle: {
            text: "취소",
            value: false,
            visible: false
          }
        }
      }).then(result => {
        if (result) {
          if (successFunction != null) {
            setTimeout(function () {
              successFunction();
            }, 2000);
          }
        }
      });
    },
    fnOnLoadSwalImageData: function (value) {
      let _icon = "/design/common/images/sub/img_alert_" + value + ".png";
      return _icon;
    },
    validationReply() {
      let vm = this;
      let userKey = $("#userKey").val();
      let replyName = vm.pareDetailModel.replyName == "" ? false : true;
      let replyPassword = vm.pareDetailModel.replyPassword == "" ? false : true;
      let content = vm.pareDetailModel.replyContents == "" ? false : true;

      if (userKey == null || userKey == "") {
        if (!replyName) {
          vm.fnSwalAlert('게스트 이름이 입력되지 않았습니다.');
          return false;
        } else if (!replyPassword) {
          vm.fnSwalAlert('게스트 비밀번호가 입력되지 않았습니다.');
          return false;
        }
      }

      if (!content) {
        vm.fnSwalAlert('내용이 입력되지 않았습니다.');
        return false;
      }

      if (userKey == null || userKey == "") {
        if (replyName && replyPassword && content) {
          return true;
        }
      } else {
        if (content) {
          return true;
        }
      }

    },
    validationRereply() {
      let vm = this;
      let userKey = $("#userKey").val();
      let reReplyName = vm.pareDetailModel.reReplyName == "" ? false : true;
      let reReplyPassword = vm.pareDetailModel.reReplyPassword == "" ? false : true;
      let content = vm.pareDetailModel.reReplyContents == "" ? false : true;

      if (userKey == null || userKey == "") {
        if (!reReplyName) {
          vm.fnSwalAlert('게스트 이름이 입력되지 않았습니다.');
          return false;
        } else if (!reReplyPassword) {
          vm.fnSwalAlert('게스트 비밀번호가 입력되지 않았습니다.');
          return false;
        }
      }

      if (!content) {
        vm.fnSwalAlert('내용이 입력되지 않았습니다.');
        return false;
      }

      if (userKey == null || userKey == "") {
        if (reReplyName && reReplyPassword && content) {
          return true;
        }
      } else {
        if (content) {
          return true;
        }
      }

    },
    //댓글 작성
    OnClickPareReviewReplyWrite: function () {
      let vm = this;

      if (vm.pareDetailModel.userKey != null && vm.pareDetailModel.userKey != "") {
        vm.pareDetailModel.replyName = vm.pareDetailModel.nickName;
      }
      vm.pareDetailModel.isReplyOn = true;
    },
    //댓글 수정
    OnClickPareReviewReplyModity: function (item) {
      let vm = this;
      vm.pareDetailModel.modifyTarget = item.replyUid;
      vm.pareDetailModel.modifyStarCnt = item.starCnt;
      vm.pareDetailModel.modifyContents = item.content;
    },
    //(비회원) 댓글 삭제
    OnClickPareReviewReplyGuestDelete: function (item) {
      let vm = this;
      vm.pareDetailModel.deleteTarget = item.replyUid;
    },
    //대댓글영역 노출
    OnClickPareReviewReReplyOn: function (uidKey) {
      let vm = this;
      vm.pareDetailModel.reReplyTarget = uidKey;
      if (vm.pareDetailModel.userKey != null && vm.pareDetailModel.userKey != "") {
        vm.pareDetailModel.replyName = vm.pareDetailModel.nickName;
      }
    },
    //댓글 비밀번호 체크(비회원)
    OnClickReplyPwChk(item) {
      let vm = this;

      let param = {
        uidKey: item.replyUid
        , guestPassword: vm.pareDetailModel.modifyPassword
      };

      Axios.post("/api/pare/contents/reply/checkPassword", param).then(function (response) {

        let result = response.data.result;

        if (result > 0) {
          vm.pareDetailModel.modifyPwCor = "Y";
        } else {
          vm.fnSwalAlert("비밀번호가 맞지 않습니다.");
          vm.pareDetailModel.modifyPassword = "";
        }

      }).catch(function (ex) {
        console.log(ex);
      });
    },

    //댓글 비밀번호 체크(비회원 삭제용)
    OnClickReplyPwChkForDelete(item) {
      let vm = this;

      let param = {
        uidKey: item.replyUid
        , guestPassword: vm.pareDetailModel.deletePassword
      };

      Axios.post("/api/pare/contents/reply/checkPassword", param).then(function (response) {

        let result = response.data.result;

        if (result > 0) {
          vm.OnClickPareReviewReplyDelete(item.replyUid);
        } else {
          vm.fnSwalAlert("비밀번호가 맞지 않습니다.");
          vm.pareDetailModel.deletePassword = "";
        }

      }).catch(function (ex) {
        console.log(ex);
      });
    },

    //대댓글영역 취소
    onClickPareReviewRereplyCancle: function () {
      let vm = this;
      vm.pareDetailModel.reReplyName = '';
      vm.pareDetailModel.reReplyPassword = '';
      vm.pareDetailModel.reReplyContents = '';
      vm.pareDetailModel.reReplyTarget = '';

      if (pageType == 'detail') {
        vm.fnGetReviewDetail();
      } else {
        vm.fnGetBoardDetail();
      }
    },
    //대댓글 작성
    onClickPareReviewRereplySubmit: function () {
      let vm = this;
      let param = {};

      let _parentUid = vm.pareDetailModel.reReplyTarget;
      let _uid = vm.pareDetailModel.boardUid;

      if (vm.pareDetailModel.userKey != null && vm.pareDetailModel.userKey != "") {
        param = {
          buid: _uid
          , userKey: vm.pareDetailModel.userKey
          , content: vm.pareDetailModel.reReplyContents
          , depth: 1
          , parentUid: _parentUid
        };
      } else {
        param = {
          buid: _uid
          , guestName: vm.pareDetailModel.reReplyName
          , guestPassword: vm.pareDetailModel.reReplyPassword
          , userKey: "USRCNFRM_00000000000" //게스트키
          , content: vm.pareDetailModel.reReplyContents
          , depth: 1
          , parentUid: _parentUid
        };
      }
      if (vm.validationRereply()) {
        Axios.post("/api/pare/contents/reReply/write", param).then(function (response) {
          let result = response.data.result;
          if (result > 0) {
            vm.fnSwalSuccess('정상적으로 등록되었습니다.', vm.onClickPareReviewRereplyCancle());
          } else if (result == -999) {
            swal({
              title: '등록 실패',
              text: '등록에 실패하였습니다(개인정보 또는 비속어 포함)',
              // icon : vm.fnOnLoadSwalImageData('error'),
              buttons: {
                cancel: {
                  text: "취소",
                  value: false,
                  visible: false
                },
                confirm: {
                  text: "확인",
                  value: true,
                  visible: true
                },
              },
              dangerMode: false
            }).then(result => {
              if (result) {
                return false;
              }
            });
          } else {
            vm.fnSwalAlert('댓글등록에 실패하였습니다.');
            return false;
          }
        }).catch(function (ex) {
          console.log(ex);
          vm.fnSwalAlert('댓글등록에 실패하였습니다.');
          return false;
        });
      }

    },
    //대댓글 수정 취소
    onClickPareReviewRemodirfyCancle: function () {
      let vm = this;
      vm.pareDetailModel.modifyContents = '';
      vm.pareDetailModel.modifyTarget = '';
      vm.pareDetailModel.modifyStarCnt = '';
      vm.pareDetailModel.modifyPwCor = '';
      vm.pareDetailModel.modifyPassword = '';

      if (pageType == 'detail') {
        vm.fnGetReviewDetail();
      } else {
        vm.fnGetBoardDetail();
      }
    },
    //대댓글 수정
    onClickPareReviewRemodirfySubmit: function (reply_uid) {
      let vm = this;
      let param = {};

      if (vm.pareDetailModel.userKey != null && vm.pareDetailModel.userKey != "") {
        param = {
          buid: vm.pareDetailModel.boardUid
          , uidKey: reply_uid
          , userKey: vm.pareDetailModel.userKey
          , content: vm.pareDetailModel.modifyContents
          , starCnt: vm.pareDetailModel.modifyStarCnt
        };
      } else {
        param = {
          buid: vm.pareDetailModel.boardUid
          , uidKey: reply_uid
          , userKey: "USRCNFRM_00000000000" //게스트키
          , content: vm.pareDetailModel.modifyContents
          , starCnt: vm.pareDetailModel.modifyStarCnt
        };
      }

      Axios.post("/api/pare/contents/reply/modify", param).then(function (response) {
        let result = response.data.result;
        if (result > 0) {
          vm.fnSwalSuccess('정상적으로 수정되었습니다.', vm.onClickPareReviewRemodirfyCancle());
        } else if (result == -999) {
          swal({
            title: '수정 실패',
            text: '수정에 실패하였습니다(개인정보 또는 비속어 포함)',
            // icon : vm.fnOnLoadSwalImageData('error'),
            buttons: {
              cancel: {
                text: "취소",
                value: false,
                visible: false
              },
              confirm: {
                text: "확인",
                value: true,
                visible: true
              },
            },
            dangerMode: false
          }).then(result => {
            if (result) {
              return false;
            }
          });
        } else {
          vm.fnSwalAlert('댓글수정에 실패하였습니다.');
          return false;
        }
      }).catch(function (ex) {
        console.log(ex);
        vm.fnSwalAlert('댓글수정에 실패하였습니다.');
        return false;
      });
    },
    //댓글 삭제
    OnClickPareReviewReplyDelete: function (reply_uid) {
      let vm = this;

      let param = {
        buid: vm.pareDetailModel.boardUid
        , uidKey: reply_uid
      };

      swal({
        text: "해당 댓글을 삭제하시겠습니까?",
        closeOnClickOutside: false,
        buttons: {
          confirm: {
            text: "확인",
            value: true
          }
          , cancle: {
            text: "취소",
            value: false
          }
        },
        dangerMode: false
      }).then(function (isConfirm) {
        if (isConfirm) {
          Axios.post("/api/pare/contents/reply/delete", param).then(function (response) {
            let result = response.data.result;
            if (result == 1) {

              let pageType = $("#pageType").val();

              if (pageType == 'detail') {
                vm.fnSwalSuccess('삭제되었습니다.', vm.fnGetReviewDetail());
              } else {
                vm.fnSwalSuccess('삭제되었습니다.', vm.fnGetBoardDetail());
              }

            } else {
              vm.fnSwalAlert('댓글삭제에 실패하였습니다.');
              return false;
            }
          }).catch(function (ex) {
            console.log(ex);
            vm.fnSwalAlert('댓글삭제에 실패하였습니다.');
            return false;
          });
        } else {
          return false;
        }
      });

    },
    //댓글 작성
    onClickPareReviewReplySubmit: function () {
      let vm = this;
      let param = {};

      let _uid = vm.pareDetailModel.boardUid;

      if (vm.pareDetailModel.userKey != null && vm.pareDetailModel.userKey != "") {
        param = {
          buid: _uid
          , starCnt: vm.pareDetailModel.replyStarCnt
          , userKey: vm.pareDetailModel.userKey
          , content: vm.pareDetailModel.replyContents
        };
      } else {
        param = {
          buid: _uid
          , starCnt: vm.pareDetailModel.replyStarCnt
          , guestName: vm.pareDetailModel.replyName
          , guestPassword: vm.pareDetailModel.replyPassword
          , userKey: "USRCNFRM_00000000000" //게스트키
          , content: vm.pareDetailModel.replyContents
        };
      }
      if (vm.validationReply()) {
        Axios.post("/api/pare/contents/reply/write", param).then(function (response) {
          let result = response.data.result;
          if (result == 1) {
            vm.fnSwalSuccess('정상적으로 등록되었습니다.', vm.onClickPareReviewReplyCancle());
          } else if (result == -999) {
            swal({
              title: '등록 실패',
              text: '등록에 실패하였습니다(개인정보 또는 비속어 포함)',
              // icon : vm.fnOnLoadSwalImageData('error'),
              buttons: {
                cancel: {
                  text: "취소",
                  value: false,
                  visible: false
                },
                confirm: {
                  text: "확인",
                  value: true,
                  visible: true
                },
              },
              dangerMode: false
            }).then(result => {
              if (result) {
                return false;
              }
            });
          } else {
            vm.fnSwalAlert('댓글등록에 실패하였습니다.');
            return false;
          }
        }).catch(function (ex) {
          console.log(ex);
          vm.fnSwalAlert('댓글등록에 실패하였습니다.');
          return false;
        });
      }
    },
    //댓글 취소
    onClickPareReviewReplyCancle: function () {
      let vm = this;
      vm.pareDetailModel.replyName = '';
      vm.pareDetailModel.replyPassword = '';
      vm.pareDetailModel.replyContents = '';
      vm.pareDetailModel.replyStarCnt = 0;
      vm.pareDetailModel.isReplyOn = false;

      let pageType = $("#pageType").val();

      if (pageType == 'detail') {
        vm.fnGetReviewDetail();
      } else {
        vm.fnGetBoardDetail();
      }

    }
    /****************************************************************************/
    , fnSetProgram(item) {
      let vm = this;

      if (item == null || item == "") {
        vm.pareInsertModel.reserveId = "";
        vm.pareInsertModel.reserveDate = "";
        vm.pareInsertModel.reserveTitle = "";
        vm.pareInsertModel.centerName_input = "";
        vm.pareInsertModel.centerUid = "";
        vm.pareInsertModel.reservePuid = "";
        vm.pareInsertModel.reserveProgramType = "";
      } else {
        vm.pareInsertModel.reserveId = item.programRegUid;
        vm.pareInsertModel.reserveDate = item.insertDate;
        vm.pareInsertModel.reserveTitle = item.programName;
        vm.pareInsertModel.centerName_input = item.centerName;
        vm.pareInsertModel.centerUid = item.centerUid;
        vm.pareInsertModel.reservePuid = item.programUid;
        vm.pareInsertModel.reserveProgramType = item.programType;
      }
    }

    , fnSelectLabelProgram(item) {
      let vm = this;

      if (item == null || item == "") {
        return "선택";
      } else {
        let str = "";

        str = str + "[" + item.round + "회차] ";
        str = str + item.programName + " ";

        if (item.reviewYn == "N") {
          str = str + "(작성가능)";
        } else {
          str = str + "(작성완료)";
        }

        return str;
      }
    }





    /****************************************************************************/
    //writePareReviewForm.jsp
    //writePareBoardViewForm.jsp
    //검색 자동완성 함수
    , changeResValue(str) {

      this.pareInsertModel.isResActive = false;
      document.querySelector('.s.res').value = str;
      this.pareInsertModel.resValue = str;
      this.pareInsertModel.reserveTitle = str;

      this.setResInfo();
    }
    , setResInfo() {
      const resInfo = this.pareInsertModel.reserveList.find(this.isSame);

      this.pareInsertModel.reservePuid = resInfo.programUid;
      this.pareInsertModel.reserveId = resInfo.programRegUid;
      this.pareInsertModel.reserveDate = resInfo.insertDate;
      this.pareInsertModel.centerName_input = resInfo.centerName;
      this.pareInsertModel.centerUid = resInfo.centerUid;
      this.pareInsertModel.reserveProgramType = resInfo.programType;

      $("#reserveEl").empty();

    }
    , setCenInfo() {
      const cenInfo = this.pareInsertModel.centerList.find(this.isCenSame);

      this.pareInsertModel.centerUid = cenInfo.uidKey;

      $("#centerEl").empty();

    }
    , isSame(element) {
      if (element.programName === this.pareInsertModel.resValue) {
        return true;
      }
    }
    , isCenSame(element) {
      if (element.userName === this.pareInsertModel.cenValue) {
        return true;
      }
    }
    , changeCenValue(str) {
      this.pareInsertModel.isCenActive = false;
      document.querySelector('.s.cen').value = str;
      this.pareInsertModel.cenValue = str;
      this.pareInsertModel.centerName = str;
      this.setCenInfo();
    }
    , selectResValue(keycode, str) {
      if (this.pareInsertModel.isResActive === true) {
        const hasClass = document.querySelector('.r').classList.contains('key');
        if (keycode === 'down') {
          if (!hasClass) {
            const thisEl = document.querySelectorAll('.r li')[0];
            document.querySelector('.r').classList.add('key');
            thisEl.classList.add('sel');
            thisEl.focus();
          } else {
            const lastEl = document.querySelector('.r li:last-child');
            const thisEl = document.querySelector('.r li.sel');
            const nextEl = thisEl.nextElementSibling;
            if (!lastEl.classList.contains('sel')) {
              thisEl.classList.remove('sel');
              nextEl.classList.add('sel');
              nextEl.focus();
            }
          }
        }
        if (keycode === 'up' && hasClass) {
          const firstEl = document.querySelectorAll('.r li')[0];
          const thisEl = document.querySelector('.r li.sel');
          const prevEl = thisEl.previousElementSibling;
          if (!firstEl.classList.contains('sel')) {
            thisEl.classList.remove('sel');
            prevEl.classList.add('sel');
            prevEl.focus();
          } else {
            document.querySelector('.s').focus();
          }
        }
        if (keycode === 'enter' && hasClass) {
          this.changeResValue(str);
        }
      }
    }
    , selectCenValue(keycode, str) {
      if (this.pareInsertModel.isCenActive === true) {
        const hasClass = document.querySelector('.r').classList.contains('key');
        if (keycode === 'down') {
          if (!hasClass) {
            const thisEl = document.querySelectorAll('.r li')[0];
            document.querySelector('.r').classList.add('key');
            thisEl.classList.add('sel');
            thisEl.focus();
          } else {
            const lastEl = document.querySelector('.r li:last-child');
            const thisEl = document.querySelector('.r li.sel');
            const nextEl = thisEl.nextElementSibling;
            if (!lastEl.classList.contains('sel')) {
              thisEl.classList.remove('sel');
              nextEl.classList.add('sel');
              nextEl.focus();
            }
          }
        }
        if (keycode === 'up' && hasClass) {
          const firstEl = document.querySelectorAll('.r li')[0];
          const thisEl = document.querySelector('.r li.sel');
          const prevEl = thisEl.previousElementSibling;
          if (!firstEl.classList.contains('sel')) {
            thisEl.classList.remove('sel');
            prevEl.classList.add('sel');
            prevEl.focus();
          } else {
            document.querySelector('.s').focus();
          }
        }
        if (keycode === 'enter' && hasClass) {
          this.changeCenValue(str);
        }
      }
    }
    , resetForm() {
      this.pareInsertModel.reservePuid = '';
      this.pareInsertModel.reserveID = '';
      this.pareInsertModel.reserveDate = '';
      this.pareInsertModel.reserveTitle_input = '';
      this.pareInsertModel.reserveTitle = '';

      this.pareInsertModel.centerUid = '';
      this.pareInsertModel.centerName = '';
      this.pareInsertModel.centerName_input = '';

      $("#reserveEl").empty();
      $("#centerEl").empty();
    }
    , removeValue() {
      if (document.querySelector('.r').classList.contains('key')) {
        document.querySelector('.r').classList.remove('key');
        document.querySelector('.r li.sel').classList.remove('sel');
      }
    }
    //신청정보리스트
    , fnOnSetResPop() {
      let vm = this;

      let param = {};

      Axios.post("/api/pare/reserveList", param).then(function (response) {

        vm.pareInsertModel.reserveList = response.data.noticeProgList;

        if (vm.pareInsertModel.reserveList.length == 0) {
          vm.pareInsertModel.reserveList = [{
            programName: "내역이 없습니다."
            , insertDate: "NO"
            , programUid: "NO"
            , programRegUid: "NO"
            , centerName: "없음"
            , centerUid: 'NO'
            , programType: 'NO'
            , reviewYn: 'N'
          }];

          vm.pareInsertModel.isEmptyPrgm = true;
        }

      }).catch(function (ex) {
        console.log(ex);
      });
    }
    //기관리스트
    , fnOnSearchCenterPop() {
      let vm = this;

      let param = {};

      Axios.post("/api/pare/centerList", param).then(function (response) {

        vm.pareInsertModel.centerList = response.data.noticeCustList;

      }).catch(function (ex) {
        console.log(ex);
      });
    }
    , fnAllSetList() {
      let vm = this;
      vm.pareInsertModel.userKey = $("#userKey").val();

      vm.fnOnSetResPop();

      let param = {};

      vm.$refs.dropimg.onMaxChange(1);
      Axios.post("/api/profile/list", param).then(function (response) {
        vm.detailProfile.url = (response.data.list == null) ? "/design/common/images/sub/img_profile_example01.jpg" : response.data.list[0].imgBase64;
        ImgProfile.props = vm.detailProfile;
      }).catch(function (ex) {
        console.log(ex);
      });
    }
    , fnSetBoardForm() {
      let _bcate = $("#bcate").val();

      this.pareInsertModel.category = _bcate;
      this.pareInsertModel.userKey = $("#userKey").val();
    }
    , fnSetThemeList() {
      let vm = this;

      let param = {
        code: "THMNV00000"
      };

      Axios.post("/api/pare/selectTheme", param).then(function (response) {

        vm.postingModel.themeList = response.data.PareCodeList;


        if (vm.postingModel.themeList.length > 0) {
          vm.postingModel.themeList.forEach(function (object) {
            if (object.cmm_sys_cd == response.data.PareCodeList.cmm_sys_cd) {
              vm.selectThemeType = object;
            }
          });
        }

      }).catch(function (ex) {
        console.log(ex);
      });
    }
    //라디오버튼 전환
    , fnSetInput(data) {
      if (data == 'reserve') {
        this.pareInsertModel.isReserve = true;
        this.pareInsertModel.isCenter = false;
        this.pareInsertModel.centerUid = '';
        this.pareInsertModel.centerName = '';
        this.pareInsertModel.reserveTitle_input = '';

        $("#reserveEl").empty();
        $("#centerEl").empty();
      } else {
        this.pareInsertModel.isReserve = false;
        this.pareInsertModel.isCenter = true;
        this.pareInsertModel.reserveTitle = '';
        this.pareInsertModel.reservePuid = '';
        this.pareInsertModel.reserveId = '';
        this.pareInsertModel.reserveDate = '';
        this.pareInsertModel.centerName_input = '';

        $("#reserveEl").empty();
        $("#centerEl").empty();
      }
    }
    , validationReview() {
      return true;
      let vm = this;

      let _reserveTitle = (vm.pareInsertModel.reservePuid == "") ? false : true;
      // || vm.pareInsertModel.reservePuid == "NO"
      // || vm.pareInsertModel.centerUid == "NO" )? false : true;
      let _star = vm.pareInsertModel.starCnt == 0 ? false : true;
      let _title = vm.pareInsertModel.title == "" ? false : true;
      let _content = vm.pareInsertModel.content == "" ? false : true;


      // 프로그램 회차내역을 미선택해도 입력가능하도록 변경
      if (!_reserveTitle) {
        vm.fnSwalAlert('프로그램이 제대로 입력되지 않았습니다.\n이수한 프로그램을 선택해주세요.');
        return false;
      } else if (!_star) {
        vm.fnSwalAlert('만족도를 입력해주세요.');
        return false;
      } else if (!_title) {
        vm.fnSwalAlert('제목을 입력해주세요.');
        return false;
      } else if (!_content) {
        vm.fnSwalAlert('내용을 입력해주세요.');
        return false;
      }

      if (vm.$refs.dropimg.cnt == 0) {
        vm.fnSwalAlert('대표이미지가 설정되지 않았습니다.\n대표이미지를 설정해주세요.');
        return false;
      }

      if (vm.$refs.dropvideo.cnt > 0) {
        if (vm.videoRes.resValue != null && vm.videoRes.resValue != "succ") {
          alert("영상이 업로드 중입니다. 잠시만 기다려주세요.");
          return false;
        }
      }

      if (vm.pareInsertModel.youtubeUrl != "") {
        if (!Validator.methods.fnValidateHmpg(vm.pareInsertModel.youtubeUrl)) {
          vm.fnSwalAlert('유효하지 않은 유튜브 URL입니다.');
          return false;
        }
      }

      // _reserveTitle은 프로그램 회차내역을 선택하지 않아도 입력가능하도록 변경됨
      if (_star && _title && _content && _reserveTitle) {
        return true;
      }
    }
    //학부모기자단 후기 등록/수정
    , fnInsertReview() {
      let vm = this;
      vm.onSaving = true;
      let type = $("#type").val();
      let _uidKey = $("#uidKey").val();

      let param = {
        boardCtg: 'BRDNVYTHNV00920'
        , boardSubCtg: vm.pareInsertModel.reserveProgramType
        , title: vm.pareInsertModel.title
        , content: vm.pareInsertModel.content
        , starCnt: vm.pareInsertModel.starCnt
        , theme: vm.pareInsertModel.theme
        , programUid: vm.pareInsertModel.reservePuid
        , centerUid: vm.pareInsertModel.centerUid
        , programRegUid: vm.pareInsertModel.reserveId
        , youtubeurl: vm.pareInsertModel.youtubeUrl
        , uidKey: _uidKey
        , fileKey: $("#fileKey").val()
      };

      if (vm.validationReview()) {
        if(vm.pareInsertModel.title == null  || vm.pareInsertModel.title == '') {
          swal('제목을 입력하세요');
          vm.onSaving = false;
          return;

        }
        if(vm.pareInsertModel.content == null  || vm.pareInsertModel.content == '') {
          swal('내용을 입력하세요');
          vm.onSaving = false;
          return;

        }
        if (type == "modify") {
          Axios.post("/api/pare/modifyPareReview", param).then(function (response) {

            let result = response.data.result;

            if (result > 0) {
              vm.fnSwalSuccess('수정이 완료되었습니다!', setTimeout(function () {
                vm.fnGoMomsDetail(_uidKey);
              }, 2500));
            } else if (result == -999) {
              swal({
                title: '수정 실패',
                text: '수정에 실패하였습니다(개인정보 또는 비속어 포함)',
                // icon : vm.fnOnLoadSwalImageData('error'),
                buttons: {
                  cancel: {
                    text: "취소",
                    value: false,
                    visible: false
                  },
                  confirm: {
                    text: "확인",
                    value: true,
                    visible: true
                  },
                },
                dangerMode: false
              }).then(result => {
                if (result) {
                  vm.onSaving = false;
                  return false;
                }
              });
            } else {
              vm.fnSwalAlert("후기 수정에 실패하였습니다.");
              vm.onSaving = false;
              return false;
            }

          }).catch(function (ex) {
            console.log(ex);
            vm.fnSwalAlert("후기 수정에 실패하였습니다.");
            vm.onSaving = false;
            return false;
          });
        } else {
          Axios.post("/api/pare/createPareReview", param).then(function (response) {

            let result = response.data.result;

            if (result > 0) {
              vm.fnSwalSuccess('등록이 완료되었습니다!', setTimeout(function () {
                vm.onSaving = false;
                vm.fnGoMomsReview();
              }, 2500));

            } else if (result == -999) {
              swal({
                title: '등록 실패',
                text: '등록에 실패하였습니다(개인정보 또는 비속어 포함)',
                // icon : vm.fnOnLoadSwalImageData('error'),
                buttons: {
                  cancel: {
                    text: "취소",
                    value: false,
                    visible: false
                  },
                  confirm: {
                    text: "확인",
                    value: true,
                    visible: true
                  },
                },
                dangerMode: false
              }).then(result => {
                if (result) {
                  vm.onSaving = false;
                  return false;
                }
              });
            } else {
              vm.fnSwalAlert("후기 등록에 실패하였습니다.");
              vm.onSaving = false;
              return false;
            }

          }).catch(function (ex) {
            console.log(ex);
            vm.fnSwalAlert("후기 등록에 실패하였습니다.");
            vm.onSaving = false;
            return false;
          });
        }
      }

    }
    , fnDeleteReview() {
      let vm = this;
      let _uidKey = $("#uid").val();

      let param = {
        uidKey: _uidKey
      };
      swal({
        text: "해당 후기를 삭제하시겠습니까?",
        closeOnClickOutside: false,
        buttons: {
          confirm: {
            text: "확인",
            value: true
          }
          , cancle: {
            text: "취소",
            value: false
          }
        },
        dangerMode: false
      }).then(function (isConfirm) {
        if (isConfirm) {
          Axios.post("/api/pare/deletePareReview", param).then(function (response) {

            let result = response.data.result;

            if (result == 1) {
              vm.fnSwalSuccess('삭제가 완료되었습니다!', setTimeout(function () {
                location.href = "/customer/pare";
              }, 2500));

            } else {
              vm.fnSwalAlert('후기 삭제에 실패하였습니다.');
              return false;
            }

          }).catch(function (ex) {
            console.log(ex);
            vm.fnSwalAlert('후기 삭제에 실패하였습니다.');
            return false;
          });
        } else {
          return false;
        }
      });


    }
    , validationBoard() {
      let vm = this;

      let _title = vm.pareInsertModel.title == "" ? false : true;
      let _content = vm.pareInsertModel.content == "" ? false : true;

      if (!_title) {
        vm.fnSwalAlert('제목을 입력해주세요.');
        return false;
      } else if (!_content) {
        vm.fnSwalAlert('내용을 입력해주세요.');
        return false;
      }

      if (vm.$refs.dropvideo.cnt > 0) {
        if (vm.videoRes.resValue != null && vm.videoRes.resValue != "succ") {
          vm.fnSwalAlert("영상이 업로드 중입니다. 잠시만 기다려주세요.");
          return false;
        }
      }

      if (vm.pareInsertModel.youtubeUrl != "" && vm.pareInsertModel.youtubeUrl != null) {
        if (!Validator.methods.fnValidateHmpg(vm.pareInsertModel.youtubeUrl)) {
          vm.fnSwalAlert('유효하지 않은 유튜브 URL입니다.');
          return false;
        }
      }

      if (_title && _content) {
        return true;
      }
    }
    , fnInsertBoard() {
      let vm = this;
      let type = $("#type").val();
      let _uidKey = $("#uidKey").val();

      let param = {
        boardCtg: vm.pareInsertModel.category
        , uidKey: vm.pareInsertModel.uidKey
        , title: vm.pareInsertModel.title
        , content: vm.pareInsertModel.content
        , youtubeurl: vm.pareInsertModel.youtubeUrl
        , fileKey: $("#fileKey").val()
      };

      if (vm.validationBoard()) {
        if (type == "modify") {
          Axios.post("/api/pare/modifyPareReview", param).then(function (response) {

            let result = response.data.result;

            if (result > 0) {

              vm.fnSwalSuccess('게시물 수정이 완료되었습니다!', setTimeout(function () {
                vm.fnGoBoardDetail(_uidKey);
              }, 2500));

            } else if (result == -999) {
              swal({
                title: '수정 실패',
                text: '수정에 실패하였습니다(개인정보 또는 비속어 포함)',
                // icon : vm.fnOnLoadSwalImageData('error'),
                buttons: {
                  cancel: {
                    text: "취소",
                    value: false,
                    visible: false
                  },
                  confirm: {
                    text: "확인",
                    value: true,
                    visible: true
                  },
                },
                dangerMode: false
              }).then(result => {
                if (result) {
                  return false;
                }
              });
            } else {
              vm.fnSwalAlert('게시물 수정에 실패하였습니다.');
              return false;
            }

          }).catch(function (ex) {
            console.log(ex);
            vm.fnSwalAlert('게시물 수정에 실패하였습니다.');
            return false;
          });
        } else {
          Axios.post("/api/pare/createPareReview", param).then(function (response) {

            let result = response.data.result;

            if (result > 0) {

              vm.fnSwalSuccess('게시물 등록이 완료되었습니다!', setTimeout(function () {
                vm.fnGoPareBoard(vm.pareInsertModel.category);
              }, 2500));

            } else if (result == -999) {
              swal({
                title: '등록 실패',
                text: '등록에 실패하였습니다(개인정보 또는 비속어 포함)',
                // icon : vm.fnOnLoadSwalImageData('error'),
                buttons: {
                  cancel: {
                    text: "취소",
                    value: false,
                    visible: false
                  },
                  confirm: {
                    text: "확인",
                    value: true,
                    visible: true
                  },
                },
                dangerMode: false
              }).then(result => {
                if (result) {
                  return false;
                }
              });
            } else {
              vm.fnSwalAlert('게시물 등록에 실패하였습니다.');
              return false;
            }

          }).catch(function (ex) {
            console.log(ex);
            vm.fnSwalAlert('게시물 등록에 실패하였습니다.');
            return false;
          });
        }
      }

    }
    , fnDeleteBoard() {
      let vm = this;
      let _uidKey = $("#uid").val();

      let param = {
        uidKey: _uidKey
      };
      swal({
        text: "해당 게시물을 삭제하시겠습니까?",
        closeOnClickOutside: false,
        buttons: {
          confirm: {
            text: "확인",
            value: true
          }
          , cancle: {
            text: "취소",
            value: false
          }
        },
        dangerMode: false
      }).then(function (isConfirm) {
        if (isConfirm) {
          Axios.post("/api/pare/deletePareReview", param).then(function (response) {

            let result = response.data.result;

            if (result == 1) {

              vm.fnSwalSuccess('게시물 삭제가 완료되었습니다!', vm.fnGoPareBoard("no"));

            } else {
              vm.fnSwalAlert('삭제에 실패하였습니다.');
              return false;
            }

          }).catch(function (ex) {
            console.log(ex);
            vm.fnSwalAlert('삭제에 실패하였습니다.');
            return false;
          });
        } else {
          return false;
        }
      });
    }
    , onEditorChangeForReview: function (event) {
      this.pareInsertModel.content = event.html;
      this.$emit('getEditorInfo', event);
    }
    , fnSetCode: function (_code) {
      let vm = this;
      let param = {
        searchCode: _code
      };

      Axios.post("/api/expinfo/code", param).then(function (response) {

        vm.declareList = response.data.expinfoCodeList;

      }).catch(function (ex) {
        console.log(ex);
      });
    }
    , fnOnDeclarePopup() {
      let vm = this;
      let _userKey = $("#userKey").val();

      if (_userKey != null && _userKey != "") {
        let param = {
          uidKey: $("#uidKey").val()
          , userKey: _userKey
        };

        Axios.post("/api/expinfo/isDeclare", param).then(function (response) {
          let result = response.data.result;
          if (result == 1) {
            vm.fnSwalAlert('접수된 신고 이력이 있습니다..');
          } else {
            vm.isDeclare = true;
          }

        }).catch(function (ex) {
          console.log(ex);
        });
      } else {
        swal({
          text: "신고하기는 로그인한 회원만 가능합니다.\n로그인하시겠습니까?",
          closeOnClickOutside: false,
          buttons: {
            confirm: {
              text: "확인",
              value: true,
              visible: true
            },
            cancle: {
              text: "취소",
              value: false,
              visible: true
            }
          }
        }).then((result) => {
          if (result) {
            location.href = "/youthnavi/signup/login";
          }
        });
      }
    }
    , fnOffDeclarePopup() {
      let vm = this;
      vm.isDeclare = false;
      vm.declareReportCode = "";
      vm.declareReportEtc = "";
    }
    , validationDeclare() {
      let vm = this;

      let declareReportCode = vm.declareReportCode == "" ? false : true;

      if (!declareReportCode) {
        vm.fnSwalAlert('신고사유가 선택되지않았습니다.');
        return false;
      } else if (vm.declareReportCode == "RPTNVYTHNV00400") {
        let declareReportEtc = vm.declareReportEtc == "" ? false : true;
        if (!declareReportEtc) {
          vm.fnSwalAlert('기타항목이 입력되지않았습니다.');
          return false;
        }
      }

      if (declareReportCode) {
        return true;
      }
    }
    , fnInsertDeclare() {
      let vm = this;

      let param = {
        boardUid: $("#uidKey").val()
        , reportKey: vm.declareReportCode
        , reportEtc: vm.declareReportEtc
        , boardCtg: "RCMNVYTHNV00200"
      };

      if (vm.validationDeclare()) {
        Axios.post("/api/expinfo/insertDeclare", param).then(function (response) {
          let result = response.data.result;
          if (result > 0) {

            vm.fnSwalSuccess("신고가 접수되었습니다.", setTimeout(function () {
              vm.fnOffDeclarePopup();
            }, 1500));

          } else if (result == -999) {
            swal({
              title: '접수 실패',
              text: '신고접수에 실패하였습니다(개인정보 또는 비속어 포함)',
              // icon : vm.fnOnLoadSwalImageData('error'),
              buttons: {
                cancel: {
                  text: "취소",
                  value: false,
                  visible: false
                },
                confirm: {
                  text: "확인",
                  value: true,
                  visible: true
                },
              },
              dangerMode: false
            }).then(result => {
              if (result) {
                return false;
              }
            });
          } else {
            vm.fnSwalAlert('오류가 발생하였습니다.');
          }
        }).catch(function (ex) {
          console.log(ex);
          vm.fnSwalAlert('오류가 발생하였습니다.');
        });
      }

    }
    , fnCheckRecommend() {
      let vm = this;
      let _userKey = $("#userKey").val();

      if (_userKey != null && _userKey != "") {
        vm.isRecommend = !vm.isRecommend;
        let _rcmmYn = (vm.isRecommend) ? 'Y' : 'N';

        if (vm.isRecommend) {
          vm.pareDetailModel.pareContents.rcmmCnt += 1;
        } else if (!vm.isRecommend) {
          vm.pareDetailModel.pareContents.rcmmCnt -= 1;
        }

        let param = {
          boardUid: $("#uidKey").val()
          , boardCtg: "RCMNVYTHNV00100"
          , rcmmYn: _rcmmYn
        };

        Axios.post("/api/expinfo/checkRecommend", param).then(function (response) {
          let result = response.data.result;
        }).catch(function (ex) {
          vm.fnSwalAlert('오류가 발생하였습니다.');
          console.log(ex);
        });
      } else {
        swal({
          text: "좋아요는 로그인한 회원만 가능합니다.\n로그인하시겠습니까?",
          closeOnClickOutside: false,
          buttons: {
            confirm: {
              text: "확인",
              value: true
            },
            cancle: {
              text: "취소",
              value: false
            }
          }
        }).then((result) => {
          if (result) {
            location.href = "/youthnavi/signup/login";
          }
        });
      }
    }
    /****************************************************************************/
    //applyPage.jsp
    //신청하기 - 자녀 tr 수 조정
    , doChild: function (index) {
      console.log(index);
      let vm = this;
      vm.applyModel.childcnt=index;

      let cnt = index;

      let _length = vm.applyModel.applyUserList.length;

      //들어온 숫자가 현재 리스트 수보다 클경우
      if (cnt > _length) {
        for (let i = 0; i < (cnt - _length); i++) {
          vm.applyModel.applyUser = {
            name: "",
            schoolType: "",
            grade: "",
            gradeList: [],
            gradeNm: ''
          };
          vm.applyModel.applyUserList.push(vm.applyModel.applyUser);
        }
        // 들어온 숫자가 현재 리스트 수보다 작을경우
      } else if (cnt < _length) {
        for (let i = 0; i < (_length - cnt); i++) {
          vm.applyModel.applyUserList.splice(-1);
        }
      }
    }
    , setChild: function (count) {
      let vm = this;

      let cnt = count

      let _length = vm.applyModel.applyUserList.length;

      //들어온 숫자가 현재 리스트 수보다 클경우
      if (cnt > _length) {
        for (let i = 0; i < (cnt - _length); i++) {
          vm.applyModel.applyUser = {
            name: "",
            schoolType: "",
            grade: "",
            gradeList: [],
            gradeNm: ''
          };
          vm.applyModel.applyUserList.push(vm.applyModel.applyUser);
        }
        // 들어온 숫자가 현재 리스트 수보다 작을경우
      } else if (cnt < _length) {
        for (let i = 0; i < (_length - cnt); i++) {
          vm.applyModel.applyUserList.splice(-1);
        }
      }
    }
    , fnChgTelNum: function (telNum) {
      let result = [];
      let restNumber = '';


      if (!telNum) {
        return "";
      }


      let value = telNum.replace(/[^0-9]/g, "");
      // 지역번호와 나머지 번호로 나누기
      if (value.startsWith("02")) {
        // 서울 02 지역번호
        result.push(value.substr(0, 2));
        restNumber = value.substring(2);
      } else if (value.startsWith("1")) {
        // 지역 번호가 없는 경우
        // 1xxx-yyyy
        restNumber = value;
      } else {
        // 나머지 3자리 지역번호
        // 0xx-yyyy-zzzz
        result.push(value.substr(0, 3));
        restNumber = value.substring(3);
      }


      if (restNumber.length === 7) {
        // 7자리만 남았을 때는 xxx-yyyy
        result.push(restNumber.substring(0, 3));
        result.push(restNumber.substring(3));
      } else {
        result.push(restNumber.substring(0, 4));
        result.push(restNumber.substring(4));
      }
      let tmpTel = result.filter((val) => val).join("-");
      return tmpTel;
    }
    , fnGetSchool() {
      let vm = this;

      let param = {
        upCode: 'DIVNVSKDNV00000'
      };

      Axios.post("/api/notice/selectCode", param).then(function (response) {

        vm.applyModel.schoolList = response.data.codeList;

      }).catch(function (ex) {
        console.log(ex);
      });
    }
    , selectChange(value, _item) {
      _item.schoolType = value;
      let param = {
        code: value
      };
      Axios.post("/api/pare/selectGrade", param).then(function (response) {

        _item.gradeList = response.data.PareCodeList;

      }).catch(function (ex) {
        console.log(ex);
      });
    }
    , fnPromiseGradeList(item, value) {
      return new Promise(function (resolve, reject) {

        let param = {
          code: value
        };
        Axios.post("/api/pare/selectGrade", param).then(function (response) {

          item.gradeList = response.data.PareCodeList;

          resolve('1');

        }).catch(function (ex) {
          console.log(ex);
        });
      })
    }
    //promise gradeList함수
    , fnPromiseSetGradeNm(_item, value) {
      return new Promise(function (resolve, reject) {
        if (value == "" || value == null || value == undefined) {
          _item.gradeNm = "선택";
        } else {
          let _grade = _item.gradeList.find(item => item.cmm_sys_cd == value);
          let _title = _grade.cmm_sys_titl;
          _item.gradeNm = _title;
        }

        resolve('1');
      })
    }
    , validationApply() {
      let vm = this;
      let childcnt = vm.applyModel.childcnt == "0" ? false : true;
      let content = vm.applyModel.content == "" ? false : true;

      if (!childcnt) {
        //vm.fnSwalAlert('자녀의 수를 선택해주세요.').then(function(){
        swal('자녀의 수를 선택해주세요.').then(function(){
          $('#child').focus();
        });
        return false;
      } else if (vm.applyModel.childcnt != "0") {
        let list = vm.applyModel.applyUserList;

        let i = 1;

        for (let idx in list) {
          let name = list[idx].name == "" ? false : true;
          let schoolType = list[idx].schoolType == "" ? false : true;
          let grade = list[idx].grade == "" ? false : true;

          if (!name) {
            //vm.fnSwalAlert('자녀' + (i) + '의 이름이 입력되지 않았습니다.\n이름을 입력해주세요.').then(function(){
            swal('자녀' + (i) + '의 이름이 입력되지 않았습니다.\n이름을 입력해주세요.').then(function(){
              $('#childName').focus();
            });
            return false;
          } else if (!schoolType) {
            //vm.fnSwalAlert('자녀' + (i) + '의 학교구분이 선택되지 않았습니다.\n학교구분을 선택해주세요.').then(function(){
            swal('자녀' + (i) + '의 학교구분이 선택되지 않았습니다.\n학교구분을 선택해주세요.').then(function(){
              $('#schoolType').focus();
            });
            return false;
          } else if (!grade) {
            //vm.fnSwalAlert('자녀' + (i) + '의 학년이 선택되지 않았습니다.\n학년을 선택해주세요.').then(function(){
            swal('자녀' + (i) + '의 학년이 선택되지 않았습니다.\n학년을 선택해주세요.').then(function(){
              $('#childGrade').focus();
            });
            return false;
          }
          i++;
        }
      }

      if (!Validator.methods.fnValidateHmpg(vm.applyModel.blog)) {
        //vm.fnSwalAlert('블로그 주소가 유효하지 않은 URL 형식입니다.').then(function(){
        swal('블로그 주소가 유효하지 않은 URL 형식입니다.').then(function(){
          $('#blog').focus();
        });
        return false;
      }

      if (!content) {
        //vm.fnSwalAlert('지원동기가 입력되지 않았습니다.\n지원동기를 입력해주세요.').then(function(){
        swal('지원동기가 입력되지 않았습니다.\n지원동기를 입력해주세요.').then(function(){
          $('#staff').focus();
        });
        return false;
      }

      if (content && childcnt) {
        return true;
      }
    }
    , doOnSubmitApply() {
      let vm = this;
      vm.applyModel.applyUserList = []
      for (var i = 0; i < vm.applyModel.childcnt; i++)
        vm.applyModel.applyUserList.push({
          name: "1",
          schoolType: "DIVNVSKDNV00100",
          grade: "DIVNVSKDNV001100",
          gradeList: [],
          gradeNm: ''
        })


      let param = {
        userKey: vm.applyModel.userKey,
        blog: vm.applyModel.blog,
        content: vm.applyModel.content,
        childcnt: vm.applyModel.childcnt,
        childList: vm.applyModel.applyUserList,
        fileKey: $("#fileKey").val()
      };

      if (vm.validationApply()) {
        Axios.post("/api/pare/insertApply", param).then(function (response) {
          let result = response.data.result;

          if (result > 0) {
            vm.fnSwalSuccess('신청이 완료되었습니다.', setTimeout(function () {
              vm.fnGoPareMenu();
            }, 2500));

          } else if (result == -999) {
            swal({
              title: '신청 실패',
              text: '학부모기자단 신청에 실패하였습니다(개인정보 또는 비속어 포함)',
              // icon : vm.fnOnLoadSwalImageData('error'),
              buttons: {
                cancel: {
                  text: "취소",
                  value: false,
                  visible: false
                },
                confirm: {
                  text: "확인",
                  value: true,
                  visible: true
                },
              },
              dangerMode: false
            }).then(result => {
              if (result) {
                return false;
              }
            });
          } else {
            vm.fnSwalAlert('오류가 발생하였습니다.\n잠시 후 다시 시도해주세요.');
            return false;
          }

        }).catch(function (ex) {
          console.log(ex);
          vm.fnSwalAlert('오류가 발생하였습니다.\n잠시 후 다시 시도해주세요.');
          return false;
        });
      }

    }

    , doOnSubmitModify() {
      let vm = this;

      let param = {
        uidKey: vm.applyModel.uidKey,
        userKey: vm.applyModel.userKey,
        blog: vm.applyModel.blog,
        content: vm.applyModel.content,
        childcnt: vm.applyModel.childcnt,
        childList: vm.applyModel.applyUserList,
        fileKey: $("#fileKey").val()
      };

      if (vm.validationApply()) {
        Axios.post("/api/pare/modifyApply", param).then(function (response) {
          let result = response.data.result;

          if (result > 0) {
            vm.fnSwalSuccess('수정이 완료되었습니다.', setTimeout(function () {
              vm.fnGoPareMenu();
            }, 2500));

          } else if (result == -999) {
            swal({
              title: '수정 실패',
              text: '수정에 실패하였습니다(개인정보 또는 비속어 포함)',
              // icon : vm.fnOnLoadSwalImageData('error'),
              buttons: {
                cancel: {
                  text: "취소",
                  value: false,
                  visible: false
                },
                confirm: {
                  text: "확인",
                  value: true,
                  visible: true
                },
              },
              dangerMode: false
            }).then(result => {
              if (result) {
                return false;
              }
            });
          } else {
            vm.fnSwalAlert('오류가 발생하였습니다.\n잠시 후 다시 시도해주세요.');
            return false;
          }

        }).catch(function (ex) {
          console.log(ex);
          vm.fnSwalAlert('오류가 발생하였습니다.\n잠시 후 다시 시도해주세요.');
          return false;
        });
      }

    }
    /****************************************************************************/
    //pareNews.jsp
    , fnOnPareNewsList: function (pageNumber, _bcate) {
      let vm = this;
      let subCtg = ''
      vm.pareNewsModel.pager.pageNo = pageNumber;

      if (_bcate == 'mom_sosic') {
        subCtg = 'BRDNVYTHNV00900'
        $("#mom_board").removeClass("on");
        $("#mom_sosic").addClass("on");
      } else {
        subCtg = 'BRDNVYTHNV00910'

        $("#mom_board").addClass("on");
        $("#mom_sosic").removeClass("on");
      }

      let param = {
        pageNo: vm.pareNewsModel.pager.pageNo
        , pageSize: vm.pareNewsModel.pager.rowSize
        , bcate: subCtg
        , kword: vm.pareNewsModel.kword
        , kind: vm.pareNewsModel.kind
      };

      Axios.post("/api/pare/board/list", param).then(function (response) {

        vm.pareNewsModel.pager.totalSize = response.data.totalCount;
        vm.pareNewsModel.pager.pageNum = (vm.pareNewsModel.pager.pageNo * vm.pareNewsModel.pager.rowSize) - vm.pareNewsModel.pager.rowSize;
        Pager.props = Pager.methods.createPager(vm.pareNewsModel.pager, vm, "list");
        vm.pareNewsModel.list = response.data.pareList;

      }).catch(function (ex) {
        console.log(ex);
      });
    }
    , fnOnClickSearch() {
      let searchid = $(".on").attr("id");
      if (searchid == "mom_sosic") {
        this.fnOnPareNewsList(1, 'mom_sosic');
        $("#mom_sosic").addClass('on');
        $("#mom_board").removeClass('on');
      } else {
        this.fnOnPareNewsList(1, 'mom_board');
        $("#mom_board").addClass('on');
        $("#mom_sosic").removeClass('on');
      }
    }
    , fnReset() {
      let vm = this;
      let _pageType = $("#pageType").val();

      if ("pareNews" == _pageType) {
        vm.pareNewsModel.kword = "";
        vm.pareNewsModel.kind = "all";
        vm.fnOnClickSearch();
      } else if ("momsReview" == _pageType) {
        vm.pareReviewModel.kword = "";
        vm.fnOnPostList(1);
      } else if ("Mento" == _pageType) {
        vm.pareManagerModel.kword = "";
        vm.pareManagerModel.kind = "all";
        vm.fnOnClickPareLSearch();
      }
    }
    , fnCheckAuth:function() {
      let param = {};
      let vm = this;
      Axios.post("/api/pare/isMomeporter", param).then(function (response) {
        let _result = response.data.result;

        if (_result == 0) {
          vm.auth = 'none';
        } else {
          vm.auth = 'apply'
        }


      }).catch(function (ex) {
        vm.fnSwalAlert('오류가 발생하였습니다.\n 잠시 후 다시 시도하여주세요.');
        console.log(ex);
      });
    }
    , fnDeclareEnter: function (value) {
      let vm = this;

      if (vm.declareReportCode.indexOf(value) > -1) {
        vm.declareReportCode = "";
      } else {
        vm.declareReportCode = value;
      }
    }
    /****************************************************************************/
    //pareManager.jsp
    , fnOnPareManagerList(pageNumber, _bcate) {
      let vm = this;

      vm.pareManagerModel.list = [{"": ""}];
      vm.pareManagerModel.menu = _bcate;


      vm.pareManagerModel.pager.pageNo = pageNumber;

      let param = {
        pageNo: vm.pareManagerModel.pager.pageNo
        , pageSize: vm.pareManagerModel.pager.rowSize
        , bcate: _bcate
      };
      Axios.post("/api/pare/mento/list", param).then(function (response) {

        vm.pareManagerModel.pager.totalSize = response.data.totalCount;
        vm.pareManagerModel.pageNum = (vm.pareManagerModel.pager.pageNo * vm.pareManagerModel.pager.rowSize) - vm.pareManagerModel.pager.rowSize;
        Pager.props = Pager.methods.createPager(vm.pareManagerModel.pager, vm, "list");
        vm.pareManagerModel.list = response.data.pareCustList;

      }).catch(function (ex) {
        console.log(ex);
      });
    }
    , fnGotoBlog(item) {
      if (item.blog == null || item.blog == undefined || item.blog == "") {
        return false;
      } else {
        window.open(item.blog);
      }
    }
    , fnOnPareLocalList: function (pageNumber) {
      let vm = this;

      vm.pareManagerModel.menu = "mentoBoard";
      vm.pareManagerModel.pager.pageNo = pageNumber;

      let param = {
        pageNo: vm.pareManagerModel.pager.pageNo
        , pageSize: vm.pareManagerModel.pager.rowSize
        , bcate: 'BRDNVYTHNV00930'
        , kword: vm.pareManagerModel.kword
        , kind: vm.pareManagerModel.kind
      };

      Axios.post("/api/pare/board/list", param).then(function (response) {

        vm.pareManagerModel.pager.totalSize = response.data.totalCount;
        vm.pareManagerModel.pageNum = (vm.pareManagerModel.pager.pageNo * vm.pareManagerModel.pager.rowSize) - vm.pareManagerModel.pager.rowSize;
        Pager.props = Pager.methods.createPager(vm.pareManagerModel.pager, vm, "list");
        vm.pareManagerModel.boardList = response.data.pareList;

      }).catch(function (ex) {
        console.log(ex);
      });
    }
    , fnOnClickPareLSearch() {
      this.fnOnPareLocalList(1);
    }
    /****************************************************************************/
    //페이지이동
    , fnGoApplyPage() {
      let _userKey = $("#userKey").val();

      if (_userKey == null || _userKey == "") {
        swal({
          text: "학부모기자단 신청은 로그인이 필요한 기능입니다.\n로그인하시겠습니까?",
          closeOnClickOutside: false,
          buttons: {
            confirm: {
              text: "확인",
              value: true
            },
            cancle: {
              text: "취소",
              value: false
            }
          }
        }).then((result) => {
          if (result) {
            location.href = "/youthnavi/signup/login";
          }
        });
      } else {
        let param = {};

        Axios.post("/api/pare/isMomeporter", param).then(function (response) {
          let _result = response.data.result;

          if (_result == 0) {
            location.href = "/customer/pare/applyMomeporter";
          } else {
            location.href = "/customer/pare/applyMomeporter?type=modify";
          }


        }).catch(function (ex) {
          vm.fnSwalAlert('오류가 발생하였습니다.\n 잠시 후 다시 시도하여주세요.');
          console.log(ex);
        });
      }
    }
    , fnGoReviewDetail(uid) {
      sessionStorage.setItem(PARE_BACK_INTENT_KEY, 'true');
      location.href = "/customer/pare/detailReview?uid=" + uid;
    }
    , fnGoWriteReview() {
      location.href = "/customer/pare/writeMomsReview";
    }
    , fnGoModifyReview(uidKey) {
      location.href = "/customer/pare/modifyMomsReview?uidKey=" + uidKey + "&pageType=modify";
    }
    , fnGoBoardDetail(uid) {
      location.href = "/customer/pare/momsBoardDetail?uid=" + uid;
    }
    , fnGoWriteBoard() {
      let searchid = $(".on").attr("id");
      let _bcate = '';

      if (searchid == 'mom_sosic') {
        _bcate = 'BRDNVYTHNV00900'
      } else if (searchid == 'mentoBoard') {
        _bcate = 'BRDNVYTHNV00930'
      } else {
        _bcate = 'BRDNVYTHNV00910'
      }

      location.href = "/customer/pare/writeMomsBoard?bcate=" + _bcate;

    }
    , fnGoModifyBoard(uidKey) {
      location.href = "/customer/pare/modifyMomsBoard?uidKey=" + uidKey;
    }
    , fnGoBoardList() {
      let ctg = this.pareDetailModel.subCtg

      if (ctg == 'BRDNVYTHNV00930') {
        location.href = "/customer/pare/momsManager";
      } else {
        location.href = "/customer/pare/momsBoard";
      }

    }
    , fnGoMomsReview() {
      location.href = "/customer/pare";
      // location.href = "/customer/pare/momsReview";
    }
    , fnGoMomsDetail(_uidKey) {
      location.href = "/customer/pare/detailReview?uid=" + _uidKey;
    }
    , fnGoPareBoard(_category) {
      if (_category == "BRDNVYTHNV00930") {
        location.href = "/customer/pare/momsManager";
      } else {
        location.href = "/customer/pare/momsBoard";
      }
    }
    , fnGoPareMenu() {
      location.href = "/customer/pare";
    }
    , fnOnClickSharePop: function () {
      this.isShare = true;
    }
    , fnOnClickCloseSharePop: function () {
      this.isShare = false;
    }
    , fnOnLoadKakaoContent: function (value) {

      let _atag = value.replace(/<(\/a|a|\/img|img|\/br|br|\/p|p|\/span|span)([^>]*)>/gi, "");
      let _nbsptag = _atag.replace(/&nbsp;/gi, "");
      let _httptag = _nbsptag.replace(/^(((http(s?))\:\/\/))([0-9a-zA-Z\-]+\.)+[a-zA-Z]{2,6}(\:[0-9]+)?(\/\S*)?/, "");

      return (_httptag.length >= 200) ? _httptag.substring(0, 200).concat('...') : _httptag;

    }
    , fnOnClickKakaoShare: function () {
      // vm.pareDetailModel.pareContents
      let vm = this;
      let pageType = $("#pageType").val();


      let content = (vm.pareDetailModel.pareContents.content == null || vm.pareDetailModel.pareContents.content == "") ? vm.pareDetailModel.pareContents.contentFirst : vm.pareDetailModel.pareContents.content;
      let _data = vm.fnOnLoadKakaoContent(content);
      let _uri = "";

      let param = {};
      let urlAddress = '';
      Axios.post("/api/url/address", param).then(function (response) {
        urlAddress = response.data.urlName;
        if ("boardDetail" == pageType) {
          _uri = urlAddress + '/customer/pare/momsBoardDetail?uid=' + vm.pareDetailModel.pareContents.uidKey + "&shared=Y";
        } else if ("detail" == pageType) {
          _uri = urlAddress + '/customer/pare/detailReview?uid=' + vm.pareDetailModel.pareContents.uidKey + "&shared=Y";
        }

        vm.fnShareLog(vm.pareDetailModel.pareContents.uidKey);

        Share.methods.fnOnCreateKakaoShareUrl(_uri
          , vm.pareDetailModel.pareContents.title
          , ""
          , ""
          , ""
          , ""
          , ""
          , ""
        );
      });


    }
    , fnOnClickNaverShare: function () {
      let vm = this;
      let _uri = '';
      let _imgPath = '';

      let param = {};
      let urlAddress = '';
      let pageType = $("#pageType").val();
      Axios.post("/api/url/address", param).then(function (response) {
        urlAddress = response.data.urlName;

        if ("boardDetail" == pageType) {
          _uri = urlAddress + '/customer/pare/momsBoardDetail?uid=' + vm.pareDetailModel.pareContents.uidKey + "&shared=Y";
        } else if ("detail" == pageType) {
          _uri = urlAddress + '/customer/pare/detailReview?uid=' + vm.pareDetailModel.pareContents.uidKey + "&shared=Y";
        }

        vm.fnShareLog(vm.pareDetailModel.pareContents.uidKey);


        if (vm.pareDetailModel.pareContents.imagePath == '' || vm.pareDetailModel.pareContents.imagePath == null) {
          _imgPath = urlAddress + "/" + vm.pareDetailModel.pareContents.imagePath;
        } else {
          _imgPath = urlAddress + '/design/common/images/sub/img_noimg.png';
        }

        Share.methods.fnOnCreateNaverShareUrl(_uri
          , vm.pareDetailModel.pareContents.title
          , _imgPath
        );
      });

    }
    , fnOnClickFacebookShare: function () {
      let vm = this;
      let _uri = '';

      let param = {};
      let urlAddress = '';
      let pageType = $("#pageType").val();
      Axios.post("/api/url/address", param).then(function (response) {
        urlAddress = response.data.urlName;
        urlAddress = response.data.urlName;
        if ("boardDetail" == pageType) {
          _uri = urlAddress + '/customer/pare/momsBoardDetail?uid=' + vm.pareDetailModel.pareContents.uidKey + "&shared=Y";
        } else if ("detail" == pageType) {
          _uri = urlAddress + '/customer/pare/detailReview?uid=' + vm.pareDetailModel.pareContents.uidKey + "&shared=Y";
        }

        vm.fnShareLog(vm.pareDetailModel.pareContents.uidKey);

        Share.methods.fnOnCreateFacebookShareUrl(_uri);
      });

    }
    , fnOnClickLinkShare: function () {
      let vm = this;
      let target = '';

      let pageType = $("#pageType").val();
      let param = {};
      let urlAddress = '';
      Axios.post("/api/url/address", param).then(function (response) {
        urlAddress = response.data.urlName;

        if ("boardDetail" == pageType) {
          target = urlAddress + '/customer/pare/momsBoardDetail?uid=' + vm.pareDetailModel.pareContents.uidKey + "&shared=Y";
        } else if ("detail" == pageType) {
          target = urlAddress + '/customer/pare/detailReview?uid=' + vm.pareDetailModel.pareContents.uidKey + "&shared=Y";
        }

        vm.fnShareLog(vm.pareDetailModel.pareContents.uidKey);

        let _url = '/customer/activity/share/link';
        _url += '?url=' + encodeURIComponent(target);


        window.open(_url, '공유하기', "width=550, height=550, toolbar=no, menubar=no, scrollbars=no, resizable=no");
      });

    }
    , fnShareLog(uidKey) {
      Axios.post("/api/logCud/insert", {
        paramUid: uidKey,
        statusCode: "share",
        version: "insert"
      }).then(function (response) {
        let result = response.data.resultCnt;
      });
    }
    , savePareState() {
      try {
        const state = {
          reviewList: this.pareReviewModel.reviewList,
          pager: {
            pageNo: this.pareReviewModel.pager.pageNo,
            rowSize: this.pareReviewModel.pager.rowSize,
            totalSize: this.pareReviewModel.pager.totalSize
          },
          kword: this.pareReviewModel.kword,
          order: this.pareReviewModel.order,
          showMore: this.showMore,
          scrollY: window.scrollY,
          timestamp: Date.now()
        };
        sessionStorage.setItem(PARE_STATE_KEY, JSON.stringify(state));
      } catch (e) {
        console.error('Failed to save pare state:', e);
      }
    }
    , restorePareState() {
      try {
        const savedState = sessionStorage.getItem(PARE_STATE_KEY);
        if (!savedState) {
          this.fnOnLoadInit();
          return;
        }
        
        const state = JSON.parse(savedState);
        const TTL = 15 * 60 * 1000; // 15분
        
        if (Date.now() - state.timestamp > TTL) {
          sessionStorage.removeItem(PARE_STATE_KEY);
          sessionStorage.removeItem(PARE_BACK_INTENT_KEY);
          this.fnOnLoadInit();
          return;
        }
        
        // 상태 복원
        this.mainName = '학부모기자단 추천';
        this.pareReviewModel.reviewList = state.reviewList || [];
        this.pareReviewModel.pager.pageNo = state.pager.pageNo || 1;
        this.pareReviewModel.pager.rowSize = state.pager.rowSize || 10;
        this.pareReviewModel.pager.totalSize = state.pager.totalSize || 0;
        this.pareReviewModel.kword = state.kword || '';
        this.pareReviewModel.order = state.order || '';
        this.showMore = state.showMore !== undefined ? state.showMore : true;
        
        // 스크롤 위치 복원
        this.$nextTick(() => {
          window.scrollTo(0, state.scrollY || 0);
        });
        
        // 백 인텐트만 제거 (상태는 유지하여 다음 복원에도 사용)
        sessionStorage.removeItem(PARE_BACK_INTENT_KEY);
        
        console.log('Pare state restored from session storage');
      } catch (e) {
        console.error('Failed to restore pare state:', e);
        sessionStorage.removeItem(PARE_STATE_KEY);
        sessionStorage.removeItem(PARE_BACK_INTENT_KEY);
        this.fnOnLoadInit();
      }
    }

  }
  ,
    filters: {
      currency: function(value) {
        let num = new Number(value);
        return num.toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
      }
    }
  , watch: {
    selectThemeType: function (newValue, oldValue) {
      this.inputThemeLabel = (newValue != '') ? newValue.cmm_sys_titl : '';
      this.pareInsertModel.theme = newValue.cmm_sys_cd;
    }
    , selectGradeValue: function (newValue, oldValue) {
      this.inputGradeLabel = (newValue != '') ? newValue.cmm_sys_titl : '';
      newValue.theme = newValue.cmm_sys_cd;
    }
  }
  , computed: {
    filterReserList() {
      let vm = this;
      const str = this.pareInsertModel.searchResQuery;
      const reg = /[^가-힣ㄱ-ㅎㅏ-ㅣa-zA-Z0-9|\s]/.test(str);

      if (reg === false && str !== '' && str !== ' ') {
        this.pareInsertModel.isResActive = true;
        return this.pareInsertModel.reserveList.filter((el) => {
          return el.programName.match(str);
        });
      } else {
        this.pareInsertModel.isResActive = false;
      }
    }
    , filterCenterList() {
      let vm = this;
      const str = this.pareInsertModel.searchCenQuery;
      const reg = /[^가-힣ㄱ-ㅎㅏ-ㅣa-zA-Z0-9|\s]/.test(str);
      if (reg === false && str !== '' && str !== ' ') {
        this.pareInsertModel.isCenActive = true;
        return this.pareInsertModel.centerList.filter((el) => {
          return el.userName.match(str);
        });
      } else {
        this.pareInsertModel.isCenActive = false;
      }
    }

  }
});
